var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as utils from '@tencent/ovb-utils';
import { TimeoutDefer } from '../libs/simple-defer';
export default {
    insertStyle: utils.insertStyle,
    loadScript: function (src, tag, timeoutMS, option) {
        var defer = new TimeoutDefer({ timeoutMS: timeoutMS });
        utils.loadScript(__assign(__assign({}, option), { src: src }), tag).then(defer.resolve)
            .catch(defer.reject);
        return defer.promise;
    },
    attr: utils.elementAttr,
    removeAttr: function (el, attributeName) {
        if (!el)
            return;
        if (attributeName) {
            if (attributeName === 'src') {
                delete el.src;
            }
            else {
                el.removeAttribute(attributeName);
            }
        }
    },
    css: utils.elementCss,
    append: function (el, childNode) {
        if (!el)
            return;
        el.appendChild(childNode);
    },
    prepend: function (el, childNode) {
        if (el.children[0]) {
            el.insertBefore(childNode, el.children[0]);
        }
        else {
            el.appendChild(childNode);
        }
    },
    addClass: utils.addClass,
    removeClass: utils.removeClass,
    hasClass: utils.hasClass,
    hide: utils.hideElement,
    show: utils.showElement,
    text: utils.elementText,
    html: utils.elementHtml,
    /**
     * 从 HTML字符串创建 HTMLElement 对象
     * @param str HTML 字符串
     * @deprecated typo，请使用 createDom 方法
     */
    creatDom: function (str) {
        return this.createDom(str);
    },
    /**
     * 从 HTML字符串创建 HTMLElement 对象
     * @param domStr HTML 字符串
     */
    createDom: function (domStr) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = domStr;
        return wrapper.firstChild;
    },
    getDomSize: function (el) {
        if (!el) {
            return { width: 0, height: 0 };
        }
        // currentStyle为ie属性
        var computedStyle = el.currentStyle ? el.currentStyle : window.getComputedStyle(el, null);
        var width = parseFloat(computedStyle.width);
        var height = parseFloat(computedStyle.height);
        return { width: width, height: height };
    },
    /**
     * 创建video标签，根据传入配置增加video标签属性等。
     */
    createVideoDom: function (options) {
        var _a = options || {}, _b = _a.attrOpts, attrOpts = _b === void 0 ? {} : _b, _c = _a.cssOpts, cssOpts = _c === void 0 ? {} : _c;
        var videoTag = document.createElement('video');
        // 设置video标签所有的attribute属性
        Object.keys(attrOpts).forEach(function (opt) {
            videoTag.setAttribute(opt, attrOpts[opt]);
        });
        // 设置video标签的style
        utils.elementCss(videoTag, cssOpts);
        return videoTag;
    },
    getElementFromConfig: function (value) {
        return typeof value === 'string' ? document.querySelector(value) : value;
    },
};
